/* GetZget trial: phone menu Dark mode switch, floating-button overlap fix, sticky checkout bar on the phone cart,
   Shop by Scene: the chosen tab slides into view on phones. */
(function(){
  /* 1. dark mode switch in the phone menu (the header toggle is hidden on phones) */
  document.querySelectorAll('.gzt-mnav__nav').forEach(function(n){
    if(n.querySelector('.gzm-dark'))return;
    var b=document.createElement('button');b.type='button';b.className='gzm-dark';b.setAttribute('data-theme-toggle','');b.setAttribute('aria-label','Dark mode');
    b.innerHTML='<span>Dark mode</span><span class="gzm-sw" aria-hidden="true"></span>';
    n.appendChild(b);
  });

  /* 2. app buttons (WhatsApp, rewards gift, etc.) that land on top of each other get stacked instead */
  var OURS='.gzt-tb,.gzy-top,.gzw-toast,.gzp-sticky,.gzx,.gzlb,.gzk-bar2,.gzt-head,header,main';
  function floats(){
    var vh=window.innerHeight,out=[],seen=[];
    function add(el){if(!el||el.nodeType!==1||seen.indexOf(el)>-1)return;seen.push(el);if(el.matches&&el.matches(OURS))return;if(/^(SCRIPT|STYLE|LINK|META|NOSCRIPT|TEMPLATE)$/.test(el.tagName))return;
      var cs=getComputedStyle(el);if(cs.position!=='fixed'||cs.display==='none'||cs.visibility==='hidden')return;
      var r=el.getBoundingClientRect();if(r.width<10||r.height<10||r.width>260||r.height>260||r.bottom<vh-300)return;out.push(el);}
    [].forEach.call(document.body.children,function(c){add(c);[].forEach.call(c.children||[],add);if(c.shadowRoot)[].forEach.call(c.shadowRoot.children,add);});
    return out;
  }
  function hit(a,b){return !(a.right<=b.left+2||a.left>=b.right-2||a.bottom<=b.top+2||a.top>=b.bottom-2);}
  function lift(el,over){var cs=getComputedStyle(el),r=el.getBoundingClientRect(),b=parseFloat(cs.bottom)||0;el.style.setProperty('bottom',(b+(r.bottom-over.top)+12)+'px','important');el.setAttribute('data-gzf','1');}
  function fix(){
    var fl=floats();if(!fl.length)return;
    var obst=[];var bar=document.querySelector('.gzk-bar2.is-on,.gzp-sticky.is-on');if(bar)obst.push(bar.getBoundingClientRect());
    fl.forEach(function(el){var r=el.getBoundingClientRect();obst.forEach(function(o){if(hit(r,o)){lift(el,o);r=el.getBoundingClientRect();}});});
    for(var i=0;i<fl.length;i++)for(var j=i+1;j<fl.length;j++){
      var a=fl[i],c=fl[j],ra=a.getBoundingClientRect(),rc=c.getBoundingClientRect();if(!hit(ra,rc))continue;
      var idA=((a.id||'')+' '+(a.className&&a.className.baseVal!==undefined?a.className.baseVal:a.className||'')).toLowerCase();
      var mover=/smile|reward|loyal|gift/.test(idA)?a:c,other=mover===a?c:a;
      lift(mover,other.getBoundingClientRect());
    }
  }
  var n=0,iv=setInterval(function(){fix();if(++n>20)clearInterval(iv);},1000);
  window.addEventListener('load',function(){setTimeout(fix,300);});
  window.addEventListener('resize',function(){clearTimeout(window.__gzfT);window.__gzfT=setTimeout(fix,250);});

  /* 3. phone cart: sticky Total + Checkout bar while the real checkout button is off screen */
  var co=document.querySelector('.gzk-sum .gzk-checkout'),form=document.getElementById('gzk-form');
  if(co&&form&&'IntersectionObserver' in window){
    var amt=co.querySelector('.gzk-checkout__amt');
    var bar=document.createElement('div');bar.className='gzk-bar2';bar.setAttribute('aria-hidden','true');
    bar.innerHTML='<span class="gzk-bar2__t"><small>Total</small><b class="notranslate">'+(amt?amt.textContent:'')+'</b></span><button type="submit" form="gzk-form" name="checkout" class="gzt-btn gzt-btn--sale" tabindex="-1">Checkout</button>';
    document.body.appendChild(bar);
    new IntersectionObserver(function(es){var on=!es[0].isIntersecting&&window.innerWidth<768;bar.classList.toggle('is-on',on);bar.setAttribute('aria-hidden',on?'false':'true');bar.querySelector('button').tabIndex=on?0:-1;setTimeout(fix,350);}).observe(co);
  }

  /* 4. Shop by Scene: when a tab is chosen, slide it into the middle of the tab bar (phones, where the bar scrolls) */
  document.querySelectorAll('.gzt-tabs').forEach(function(bar){
    bar.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('button');if(!b||bar.scrollWidth<=bar.clientWidth+2)return;
      var x=b.offsetLeft-bar.offsetLeft-(bar.clientWidth-b.offsetWidth)/2;
      try{bar.scrollTo({left:Math.max(0,x),behavior:'smooth'});}catch(err){bar.scrollLeft=Math.max(0,x);}
    });
  });
})();
